import React from 'react';
import { useTheme } from '@material-ui/core/styles';

import { getIconColour } from '../../../../helpers/app';
import CrmSection from './CrmSection';
import FingerPrintIcon from '../../../../assets/icons/FingerPrint';
import { StyledGrid, AppInfo } from './common';
import { privacyAndTermsState } from './helper';
import { ApplicationInterface } from '../../../../interfaces/application';

type PropsType = {
  application: ApplicationInterface;
};

const CrmPrivacyAndTerms: React.FC<PropsType> = ({ application }) => {
  const type = privacyAndTermsState(application);
  const theme = useTheme();

  return (
    <CrmSection
      icon={<FingerPrintIcon stroke={getIconColour(type, theme)} />}
      title="Privacy & Terms of Use"
      description="Privacy Policy and Terms of Use documents."
      type={type}
    >
      <StyledGrid>
        <AppInfo label="Link to Privacy Policy" value={application.info.privacyUrl} />
        <AppInfo label="Link to Terms of Use" value={application.info.termsUrl} />
      </StyledGrid>
    </CrmSection>
  );
};

export default CrmPrivacyAndTerms;
